/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class ScreenNameEnum.
* @enum {}
* @readonly
*/
export default class ScreenNameEnum {
    
        /**
         * value: "TOP"
         * @const
         */
        "TOP" = "TOP";

    
        /**
         * value: "AGENT_DETAIL"
         * @const
         */
        "AGENT_DETAIL" = "AGENT_DETAIL";

    

    /**
    * Returns a <code>ScreenNameEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ScreenNameEnum} The enum <code>ScreenNameEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

